import { IHttpClient } from '@/core/services/http'

export function createGetPrivacyPolicyUseCase({
  httpClient,
}: {
  httpClient: IHttpClient
}) {
  return async function () {
    try {
      const response = await httpClient
        .version('v1')
        .get<{ data: string }>('/website/customer/PrivacyPolicy')

      return response.data.data
    } catch (_) {
      return ''
    }
  }
}
